import { getUpdateBankAccountInstruction, BankFormState, CompanyFormState, CompanyFieldMetaData } from "shared/utils/fieldsHelper/companyFields";
import { FormSection } from "components/MainSectionTemplate/types";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import React from "react";

export const bankDetailSection = (
  companyFormState: CompanyFormState,
  formState: BankFormState,
  fieldMetaData: CompanyFieldMetaData
): FormSection => {
  return {
    type: "collapsable",
    title: RESX.BankAccount.BankAccountDetails,
    key: "companyBankDetails",
    fields: [{
      ...fieldMetaData.accountNumber.fields(),
      key: "accountNumber",
      label: RESX.BankAccount.AccountNumber,
      render: () => <div>{formState.accountNumber}</div>,
      inPageEdit: {
        initialValue: formState.accountNumber,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxIbanNumberLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(companyFormState, formState, {
            accountNumber: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      ...fieldMetaData.beneficiaryName.fields(),
      key: "beneficiaryName",
      label: RESX.BankAccount.BeneficiaryName,
      render: () => <div>{formState.beneficiaryName}</div>,
      inPageEdit: {
        initialValue: formState.beneficiaryName,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxBeneficiaryNameLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(companyFormState, formState, {
            beneficiaryName: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      ...fieldMetaData.swiftCode.fields(),
      key: "swiftCode",
      label: RESX.BankAccount.SwiftCode,
      render: () => <div>{formState.swiftCode}</div>,
      inPageEdit: {
        initialValue: formState.swiftCode,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxSwiftCodeLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(companyFormState, formState, {
            swiftCode: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      ...fieldMetaData.sortCode.fields(),
      key: "sortCode",
      label: RESX.BankAccount.BsbNumber,
      render: () => <div>{formState.sortCode}</div>,
      inPageEdit: {
        initialValue: formState.sortCode,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxSortCodeLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(companyFormState, formState, {
            sortCode: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }, {
      ...fieldMetaData.bankAddress.fields(),
      key: "bankAddress",
      label: RESX.BankAccount.Bank,
      render: () => <div>{formState.bankAddress}</div>,
      inPageEdit: {
        initialValue: formState.bankAddress,
        fullWidth: true,
        render: ({ value, onChange, submit, cancel }) => (
          <OptionalTextInput
            focusOnMount
            value={value}
            maxLength={serverReference.constants.bankAccount.maxBankAddressLength}
            onChange={onChange}
            onEnter={submit}
            onEsc={cancel}
          />
        ),
        type: "confirmOrCancelButton",
        submitChange: (value) => {
          const instruction = getUpdateBankAccountInstruction(companyFormState, formState, {
            bankAddress: value
          });
          return window.CoreApi.Company.UpdateDetails(instruction);
        },
      }
    }]
  }
}